import { BAILocale } from '.';
import th_TH from 'antd/es/locale/th_TH';

const localeValue: BAILocale = {
  lang: 'th',
  antdLocale: th_TH,
};

export default localeValue;
